import { useNodeMeasuredWidth } from "../../hooks/useNodeMeasuredWidth";
import { NodeLinkDisplay } from "./NodeLinkDisplay";

interface DynamicNodeLinkDisplayProps {
  nodeId: string;
  link: string;
  isViewOnlyMode: boolean;
  onLinkClick: () => void;
}

/**
 * Wrapper component that calculates dynamic URL truncation based on node width
 * Only re-renders when measured.width changes, not on other node property changes
 */
export function DynamicNodeLinkDisplay({
  nodeId,
  link,
  isViewOnlyMode,
  onLinkClick,
}: DynamicNodeLinkDisplayProps) {
  const measuredWidth = useNodeMeasuredWidth(nodeId);

  // Calculate dynamic URL truncation based on available width
  // Account for fixed overhead: icon (15px) + gaps (4px + 4px) + padding buffer (~5px) = ~28px
  const LINK_ICON_WIDTH = 28;
  const CHARS_PER_PIXEL = 0.13;
  const urlTruncateLength = measuredWidth
    ? Math.floor((measuredWidth - LINK_ICON_WIDTH) * CHARS_PER_PIXEL)
    : 33;

  return (
    <NodeLinkDisplay
      link={link}
      isViewOnlyMode={isViewOnlyMode}
      onLinkClick={onLinkClick}
      urlTruncateLength={urlTruncateLength}
    />
  );
}
